import { Observable } from 'rxjs';
import { Component, Input, OnDestroy } from '@angular/core';

import { NgbModal, NgbActiveModal, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { BannerItem, FileRef, BannerOption, Page } from '@shared/data';

import { Language } from '@shared/data';
import { InputImageEvent } from '@shared/modules/input-image';

import { LoadingService } from '@shared/modules/loading';
import { LanguageService } from '@shared/services';

@Component({
  moduleId: 'module.id',
  selector: 'edit-banner-item',
  styles: [require('./edit-banner-item.component.scss')],
  template: require('./edit-banner-item.component.html'),
})
export class EditBannerItemComponent implements OnDestroy  {
  @Input()
  public item: BannerItem;

  @Input()
  public option: BannerOption;

  public error: Parse.Error;

  public lang: string;
  public languages: Observable<Language[]>;

  constructor(
    public activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private loadingService: LoadingService) {

    this.languages = this.languageService.find();
    this.lang = this.languageService.defaultLang;
  }

  public ngOnDestroy() {

  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onSave(): void {
    this.activeModal.close(this.item);
  }

  public onCancel(): void {
    this.item.revert();
    this.activeModal.dismiss('');
  }

  public onDismiss(): void {
    this.item.revert();
    this.activeModal.dismiss('Cross click');
  }

  public onImageChange(event: InputImageEvent): void {
    if (!this.item.getImage(this.lang)) {
      this.item.setImage(new FileRef(), this.lang);
    }

    this.item.getImage(this.lang).setFile(event.file, event.data);
  }

  public onImageSelect(event: FileRef) {
    this.item.setImage(event, this.lang);
  }

  public onError(error) {
    this.error = error;
  }

  public onTabChange(evt: NgbTabChangeEvent) {
    this.lang = evt.nextId;

    let image = this.item.getImage(this.lang);

    if (!image || image.isNew()) {
      return;
    }

    this.loadingService.continue();

    image.fetch().then(
      result => {
        this.loadingService.complete();
      },
      error => {
        this.loadingService.complete();
      }
    )
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+banner/edit-banner-item/edit-banner-item.component.ts